module.exports = __webpack_public_path__ + "static/media/answer2.f9bf4ff2.svg";